module.exports = __webpack_public_path__ + "static/media/po-Reman_Major_PumpFuelInj.901072d2.png";